var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view-field',{attrs:{"label":_vm.label,"is-visible":_vm.isVisible}},[_c('widget-value',{attrs:{"value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }